var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"charge-order-table"},[_c('Table',{attrs:{"columns":_vm.tableColumns,"data":_vm.tableList,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }